import { observable, action } from 'mobx';
import agent from '../services/web/agent';
import { setter } from 'mobx-decorators';
import erorrHandler from '../services/web/erorrHandler';

class ResetPasswordByManagerStore {

  @observable errors = null;
  @observable isError = null;
  @observable errorMessage = null;

  @observable resetPasswordByManagerProgress;
  @setter @observable userId;
  @setter @observable userName;
  @observable generatedPassword;
  
  @action resetPasswordByManager(userId) {
    
    this.resetPasswordByManagerProgress = true;

    return agent.Users.resetPasswordByManager(userId)
      .then(action((res) => {
          
          this.generatedPassword = res.generatedPassword;
      }))
      .catch(action((err) => {

          this.errorMessage = erorrHandler.getErrorMessage(err);
      
          throw err;
      }))
      .finally(action(() => {

          this.resetPasswordByManagerProgress = false;
      }));
  }
}

export default new ResetPasswordByManagerStore();